import api from './api'
import type {
  PackageRequest,
  PackageCountry,
  ApiResponse
} from '@/types'

export const packageRequestService = {
  /**
   * Get all package requests
   */
  async getAll(params?: Record<string, any>): Promise<ApiResponse<PackageRequest[]>> {
    const response = await api.get('/package-requests', { params })
    return response.data
  },

  /**
   * Get package request details by ID
   */
  async getById(id: number): Promise<ApiResponse<PackageRequest>> {
    const response = await api.get(`/package-requests/${id}`)
    return response.data
  },

  /**
   * Get countries for package requests
   */
  async getCountries(): Promise<ApiResponse<PackageCountry[]>> {
    const response = await api.get('/package-requests/countries')
    return response.data
  },

  /**
   * Create a new package request
   */
  async create(data: any): Promise<ApiResponse<PackageRequest>> {
    const response = await api.post('/package-requests', data)
    return response.data
  },

  /**
   * Add a reply to a package request
   */
  async addReply(packageRequestId: number, formData: FormData): Promise<ApiResponse<any>> {
    const response = await api.post(`/package-requests/${packageRequestId}/replies`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }
}

export default packageRequestService
